import React from "react";
import { Typography, Stack } from "@mui/material";
import { isMobile } from "react-device-detect";

const Nosotros = () => {
  return (
    <Stack sx={{ backgroundColor: "#6699ff", padding: "1rem", position: 'relative',zIndex:100 }}>

        <Stack sx={{width: isMobile ? '100%':'80%', margin:'0 auto'}} >
      <Typography color="#ffffff" sx={{textAlign:  isMobile ? 'start':'center' , fontSize: !isMobile ? '2rem':'1.8rem', padding: isMobile ? '1rem 0': '2rem 0'}} variant="h3">
        ¿POR QUÉ CONFIAR EN NOSOTROS?
      </Typography>
      <Typography sx={{textAlign: isMobile ? 'start': 'center', padding: isMobile ? '1rem 0': '2rem 0' , paddingTop:'0', fontSize: !isMobile ? '1.3rem': '.8rem'}} color="#ffffff" variant="body1">
      En ConectaTech, nos dedicamos a conectar sueños. Sabemos lo que está en juego para ti, por eso nos comprometemos a ofrecerte las mejores opciones del mercado. Somos el nexo entre personas y empresas, facilitando soluciones que marcan la diferencia.

Delega en nosotros las tareas complejas y enfócate en lo que sigue. Ofrecemos soluciones rápidas, eficientes y garantizadas, diseñadas para ser la respuesta definitiva a las necesidades de tu empresa o tu hogar.

Utilizamos tecnología de última generación para asegurar los mejores resultados, porque creemos que la innovación es la clave para construir un futuro más conectado y eficiente.

En ConectaTech, no solo conectamos opciones, conectamos posibilidades.
      </Typography>
    </Stack>
    </Stack>
  );
};

export default Nosotros;
